var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotographIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3015",
    "data-name": "Grupo 3015",
    transform: "translate(-29 -628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_459",
    "data-name": "Caminho 459",
    d: "M15.328,14.557a1.257,1.257,0,0,1-1.257,1.257H2.757A1.257,1.257,0,0,1,1.5,14.557V7.643A1.257,1.257,0,0,1,2.757,6.386H5.271L6.528,4.5H10.3l1.257,1.886h2.514a1.257,1.257,0,0,1,1.257,1.257Z",
    transform: "translate(37.645 635.073)",
    fill: "none",
    stroke: "#fff595",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_460",
    "data-name": "Caminho 460",
    d: "M17.028,16.014A2.514,2.514,0,1,1,14.514,13.5,2.514,2.514,0,0,1,17.028,16.014Z",
    transform: "translate(31.544 629.845)",
    fill: "none",
    stroke: "#fff595",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2392",
    "data-name": "Grupo 2392",
    transform: "translate(-40 735)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1288",
    "data-name": "Ret\\xE2ngulo 1288",
    width: 34,
    height: 34,
    rx: 10,
    transform: "translate(69 -107)",
    fill: "#fff595",
    opacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotographIcon);
export default __webpack_public_path__ + "static/media/photographIcon.74c73e9b174dc5ff5029fef43953e77a.svg";
export { ForwardRef as ReactComponent };